export enum ALGOLIA_INDEX_NAMES {
  IAP_PRODUCTS = 'iaps-products',
  IAP_SUBSCRIPTIONS = 'iaps-subscriptions',
  TRANSLATIONS = 'translations',
}
